import React  from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import AccountSidebar from '../components/AccountSidebar/AccountSidebar'
import MyAddressesContainer from '../components/MyAddressesContainer/MyAddressesContainer'
import Footer from '../components/Footer/Footer'
import { Col, Container, Row } from 'react-bootstrap'

function MyAddresses() {

  return (
    <>
    <NavbarContainer/>
    <Container>
      <Row>
        <Col md={3}>
        <AccountSidebar/>

        </Col>
        <Col md={9}>
<MyAddressesContainer/>
        </Col>
      </Row>
    </Container>
    <Footer/>
    </>
      )
}

export default MyAddresses